import React, { useEffect } from "react";
import "./home.css";
import Landing from "../landing/Landing";
import Details from "./details/Details";
import About from "./about/About";
import Rooya from "./rooya/Rooya";
import Contact from "./contact/Contact";

function Home(props) {
  return (
    <div className="home">
      <Landing />
      <Details />
      {/* <About /> */}
      {/* <Rooya /> */}
      <Contact />
    </div>
  );
}

export default Home;
